import { gql } from "@apollo/client";

export const FETCH_ALL_MARKETING_MATERIALS = gql`
  query FETCH_ALL_MARKETING_MATERIALS {
    allMarketingMaterials {
      id
      name
      category
      cover
      coverSrc
      asset
      assetSrc
      createdAt
      updatedAt
    }
  }
`;

export const CREATE_MARKETING_MATERIAL = gql`
  mutation CREATE_MARKETING_MATERIAL(
    $name: String
    $category: String
    $cover: Upload!
    $asset: Upload!
  ) {
    createMarketingMaterial(
      name: $name
      category: $category
      cover: $cover
      asset: $asset
    ) {
      marketingMaterial {
        id
        name
        category
        cover
        coverSrc
        asset
        assetSrc
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_MARKETING_MATERIAL = gql`
  mutation UPDATE_MARKETING_MATERIAL(
    $id: ID!
    $name: String
    $category: String
    $cover: Upload
    $asset: Upload
  ) {
    updateMarketingMaterial(
      id: $id
      name: $name
      category: $category
      cover: $cover
      asset: $asset
    ) {
      marketingMaterial {
        id
        name
        category
        cover
        coverSrc
        asset
        assetSrc
        createdAt
        updatedAt
      }
    }
  }
`;
